import React from 'react';
import PropTypes from 'prop-types';

import ErrorIcon from '@material-ui/icons/ErrorOutline';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import BaseDialog from '../BaseDialog/BaseDialog';

import { getString } from '../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ErrorDialog extends React.Component {
  constructor() {
    super();

    this.state = {
      dialogOpen: true,
    };

    this.logout = this.logout.bind(this);
    this.refresh = this.refresh.bind(this);
  }

  logout() {
    const { dialogOpen } = this.state;
    const { logout } = this.props;
    logout();
    this.setState({
      dialogOpen: !dialogOpen,
    });
  }

  refresh() {
    const { dialogOpen } = this.state;
    const { refresh } = this.props;
    refresh();
    this.setState({
      dialogOpen: !dialogOpen,
    });
  }

  render() {
    const {
      classes,
      theme,
      text,
      type,
      refresh,
      primaryButtonLabel,
    } = this.props;
    const { dialogOpen } = this.state;
    const stringsComponent = 'errorDialog';

    return (
      <div>
        <BaseDialog
          open={dialogOpen}
          content={text}
          buttonAction={this.logout}
          buttonLabel={
            primaryButtonLabel
              ? primaryButtonLabel
              : getString(stringsComponent, 'BUTTON_LABEL_LOGOUT')
          }
          secondaryButtonAction={refresh ? this.refresh : null}
          secondaryButtonLabel={
            refresh ? getString(stringsComponent, 'BUTTON_LABEL_REFRESH') : null
          }
          icon={type == 'notfound' ? InfoIcon : ErrorIcon}
        />
      </div>
    );
  }
}

ErrorDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
  refresh: PropTypes.func,
  type: PropTypes.oneOf(['error', 'notfound']),
  primaryButtonLabel: PropTypes.string,
};

ErrorDialog.defaultProps = {
  refresh: null,
  primaryButtonLabel: null,
  type: 'error',
};

export default withStyles(styles, { withTheme: true })(ErrorDialog);
